<style lang="less" scoped>
  .allkyxx{width: 100%;height: 100%;position: relative;
    .tree_box{position: absolute;left:0;width: 17%;height: 850px;overflow: auto;}
    .form_box{position: absolute;left:18%;width:82%;
      tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
      .tr .td {float: left;}
      .tr {width: 100%;height: 50px;}
      .table {border-collapse: collapse;width: 100%;}
      .select1 .el-input__inner {width: 150px;}
      .ziduanKey .el-input__inner {width: 340px;}
      .level .el-input__inner {width: 150px;}
      .sort .el-input__inner {width: 150px;}
      .date-picker.el-input {width: 200px;}
      .count .el-input__inner {width: 50px;}
      .el-checkbox {margin-right: 0px;}
      .el-checkbox__inner {border-radius: 50%;}
      .btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
      .btnbox .elbtn {margin-top: 10px;margin-left: 15px;}
      .recycling_box .delete {margin-left: 40px;}
      .btnbox .level {margin-left: 10px;}
      .el-form-item {float: left;margin-bottom: 0px;}
      .el-pagination {text-align: center;}
      .el-form table {width: 100%;}
      .tr1 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
      .tr2 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
      .select1 /deep/ .el-input__inner {width: 150px;}
      .ziduanKey /deep/ .el-input__inner {width: 340px;}
      .level /deep/ .el-input__inner {width: 150px;}
      .sort /deep/ .el-input__inner {width: 150px;}
      .count /deep/ .el-input__inner {width: 50px;}
      .pagination{margin-bottom: 40px;}
      /deep/ .el-table__body-wrapper{height: 590px;}
    }
  }
</style>

<template>
  <div class="allkyxx" id="second">
    <div class="tree_box">
      <el-tree
        :data="data"
        show-checkbox="true"
        node-key="id"
        ref="tree"
        @check="handleClick"
        :default-checked-keys="nodeId"
        :default-expanded-keys="idArr"
        :props="defaultProps"
        :filter-node-method="filterNode"
        :check-on-click-node="true"
        @node-contextmenu="openMenu">
        <span class="custom-tree-node" slot-scope="{node, data}" :class="(data.url || data.glid === 0)?opacty1:opacty2">
          <span>{{node.label}}</span>
        </span>
      </el-tree>
    </div>
    <div class=form_box>
      <!-- <KyxxAdd></KyxxAdd> -->
      <div class="dmkclb—_box second">
      <el-form ref="form" :model="form">
        <table class="dmkclb">
          <tr class="tr tr1">
            <td>
              <el-form-item>
                <div class="td">
                  <el-input v-model="form.title" placeholder="请输入关键词" class="input ziduanKey"></el-input>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-button class="elbtn search" @click="search">搜索</el-button>
                  <el-button class="elbtn reset" @click="cancelfnBtn()">重置</el-button>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-button type="success" @click="addfn()">添加</el-button>
                  <el-button type="primary" @click="addfns()">添加树节点</el-button>
                </div>
              </el-form-item>
            </td>
          </tr>
        </table>
      </el-form>
      <div class="el-tablebox">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe
          border
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center'}">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="name" label="英文名称"> </el-table-column>
          <el-table-column prop="namec" label="中文名称"> </el-table-column>
          <el-table-column prop="maptype" label="图层类型"> </el-table-column>
          <el-table-column prop="url" label="URL" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="layer" label="图层" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="showlevel" label="显示级别" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="filter" label="过滤条件">
          </el-table-column>
          <el-table-column prop="id" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="warning" @click="updatafn(scope.row)">修改</el-button>
              <el-button type="danger" @click="deletefn(99, 31, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btnbox">
        <el-button class="elbtn delete" @click="deletesfn(99, 31)">批量删除</el-button>
      </div>
    </div>
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>
    </div>
  </div>
</template>

<script>
/***
 * 李旭
 * 矿业信息地图列表页
 */
import filters from '../method/filter'
import {mapState} from 'vuex'
import KyxxAdd from '../../../../static/form/KyxxAdd.vue'
export default {
  mixins: [filters],
  components: {
    KyxxAdd
  },
  data()
  {
    return {
      count: 9,
      pageSize: 20,
      currentPage: 1,
      countSum: null,
      //分类数据
      classifydata: [],
      //列表数据
      tableData: [],
      show1: false,
      show2: false,
      show3: false,
      parms: '',
      urlShow: '',
      isdialogVisible: false,
      form: {
        title: ''
      },
      data: [],
      idArr: [], //默认展示的节点
      defaultProps: {
        children: 'children',
        label: 'namec',
        disabled: function(data, node)
        {
          if (data.children && data.children.length > 0)

            return true
    
          else
            return false
        }
      },
      showData: [{value: 1, label: '点'}, {value: 2, label: '线'}, {value: 3, label: '面'}] //显示级别类型
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID,
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
      //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then((ret) =>
        {
          this.classifydata = []
          ret.forEach((item) => this.classifydata.push({ value: item.id, label: item.dispc }))
        })
      },
      immediate: true
    },
    IsLb:
    {
      handler(nval, oval)
      {
        if (nval === '1')
        {
          this.getWMS()
          this.getList()
        }
        this.$store.commit('onIsLb', '0')
      },
      deep: true,
      immediate: true
    }
  },
  created()
  {
    this.getWMS()
    // this.getList()
  },
  methods: {
    //获取数据
    getList(att)
    {
      let count = this.count
      let currentPage = this.currentPage
      let exp = ''
      for (let e in this.form)
      {
        let item = this.form[e]
        if (item && e === 'title')
          exp += `namec like '%${item}%'`
      }
      exp = exp ? `${exp}id != 0` : `id > 0 and namec like '%${att}%'`
      let paras = {cmd: 'query', _major: 99, _minor: 31, _exp: exp, init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: 'id ASC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.countSum = ret[0].total
        this.tableData = []
        ret[0].data.forEach(item =>
        {
          this.tableData.push({
            id: item.id,
            name: item.name,
            namec: item.namec,
            maptype: item.maptype,
            url: item.url,
            layer: item.layer,
            showlevel: item.showlevel ? this.showData.filter(items => items.value === item.showlevel)[0].label : item.showlevel,
            filter: item.filter
          })
        })
      })
    },
    //取wms图层服务
    getWMS()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 31, _exp: 'visible=1', vals: this.Title}
      window.post.getPost(paras).then((ret) =>
      {
        let layerNds = ret.map(item => cx.base.extend({}, item, {children: []}))
        this.data = this.getNodes(layerNds)
        this.idArr = []
        this.data.forEach(item =>
        {
          this.idArr.push(item.id)
        })
      })
    },
    /**
     * 构造树节点
     * @method
     * @param     {Array<Object>}   nodes   节点数组
     * @returns   {Array<Object>}           构造好的树节点集合
     */
    getNodes(nodes)
    {
      let flterNodes = nodes.filter(node => node.glid === 0)
      for (let i = 0, il = flterNodes.length; i < il; ++i)
        this.makeChildrenData(flterNodes[i].children, flterNodes[i].id, nodes)
      return nodes.filter(node => node.glid === 0)
    },
    /**
     * 构造children数据
     * @method
     * @param   {Array<Object>}   children    父节点的children对象
     * @param   {Number}          glid        父节点的id
     * @param   {Array<Object>}   data        所有节点的源数据集合
     */
    makeChildrenData(children, glid, data)
    {
      let flterData = data.filter(item => item.glid === glid)
      for (let i = 0, il = flterData.length; i < il; ++i)
      {
        //判断该节点是否有图层
        if (!flterData[i].filter)
          flterData[i].icon = 'iconfont icon-bukeshi'
        children.push(flterData[i])
        if (data.some(node => node.glid === flterData[i].id))
          this.makeChildrenData(flterData[i].children, flterData[i].id, data)
      }
    },
    //点击修改
    updatafn(row)
    {
      this.$router.push({path: '/KyxxUpdate', query: {id: row.id}})
    },
    //点击查看地图
    preview1(url)
    {
      if (url)
        window.open(url, '_blank')
      else
        this.$message({message: '您还没有上传地图', type: 'error', customClass: 'mzindex'})
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      // window.public.deletefn(major, minor, row, that)
      that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>
      {
        let obj = {
          cmd: 'delete',
          _major: major,
          _minor: minor,
          id: row.id
        }
        window.post.getPost(obj).then((ret) =>
        {
          if (ret.ret === 1)
            that.$message({message: '删除失败', type: 'error', customClass: 'mzindex'})
          else
          {
            this.getWMS()
            that.getList()
            that.$message({message: '删除成功', type: 'success', customClass: 'mzindex'})
          }
        })
      }).catch(() =>
      {
        that.$message({message: '已取消删除', type: 'info', customClass: 'mzindex'})
      })
    },
    /**
     * 彻底删除——多
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletesfn(major, minor)
    {
      let that = this
      window.public.deletesfn(major, minor, that)
    },
    //子组件调用新增添加Tabs
    addfn()
    {
      this.$emit('addTab')
    },
    //子组件调用新增添加Tabs
    addfns()
    {
      this.$emit('addTab1')
    },
    //————列表页的公共方法————
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    },
    handleClick(data, tree)
    {
      this.$refs.tree.setCheckedKeys([]) // 删除所有选中节点
      this.$refs.tree.setCheckedNodes([data]) // 选中已选中节点
      if (data.glid > 0)
      {
        this.tableData.splice(0, this.tableData.length)
        this.getList(data.namec)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/KyxxLB.vue